import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  } to {
    opacity: 0;
  }
`;

const slideIn = keyframes`
  from {
    transform: translateX(-100%);
  } to {
    transform: translateX(0);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
  } to {
    transform: translateX(-100%);
  }
`;

export const ModalContainer = styled.article`
  position: absolute;
  top: 0;
  left: 0;
  
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 0 30px;
  padding-top: 120px;
  padding-bottom: 40px;
  
  color: ${({ theme }) => theme.black};
  
  background-color: ${({ theme }) => theme.white};
  box-shadow: 0 12px 48px 0 rgba(0, 0, 0, 0.1);
  
  overflow-y: scroll;
  
  @media(min-width: 550px) {
    width: 550px;
    padding: 0 80px;
    padding-top: 180px;
    padding-bottom: 40px;
  
    overflow-y: visible;
  }
`;

export const ModalOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  
  width: 100%;
  height: 100%;
  
  background-color: rgba(0, 36, 51, 0.1);
`;

export const ModalClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 50px;
  height: 50px;
  margin: 0;
  padding: 0;
  
  border-radius: 0 0 0 60px;
  border: none;
  outline: none;
  background: linear-gradient(135deg, #2DB9FE 0%, #4EDBFC 100%);
  box-shadow: 0 8px 20px 0 rgba(30, 182, 255, 0.24);
  
  cursor: pointer;
  
  svg {
    margin-top: -10px;
    margin-right: 10px;
    stroke: ${({ theme }) => theme.white}
  }
`;

export const ModalHeading = styled.h2`
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
  
  span {
    color: ${({ theme }) => theme.blue};
  }
  
  @media(min-width: 520px) {
    font-size: 36px;
    line-height: 45px;
  }
`;

export const ModalDescription = styled.p`
  margin: 0;
  margin-bottom: 30px;
  padding: 0;
  
  @media(min-width: 520px) {
    margin-bottom: 65px;
    
    font-size: 16px;
    line-height: 20px;
  }
`;

export const ModalFooter = styled.div`
  margin-top: auto;
  padding-top: 50px;
  
  font-size: 13px;
  line-height: 17px;
  
  a {
    font-weight: 700;
    color: inherit;
    
    transition: color 0.3s;
    
    &:hover {
      color: ${({ theme }) => theme.blue};
    }
  }
  
  @media(min-width: 520px) {
    font-size: 16px;
  }
`;

export const LogoContainer = styled.div`
  position: absolute;
  top: 35px;
  left: 40px;
  
  svg {
    fill: ${({ theme }) => theme.blue}
  }
`;

export const ModalWrapper = styled.div`
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  
  width: 100%;
  height: 100%;
  
  &.modal-enter-active {
    ${ModalOverlay} {
      animation: ${fadeIn} 0.5s forwards;
    }
    
    ${ModalContainer} {
      animation: ${slideIn} 0.5s forwards;
    }
  }
  
  &.modal-exit-active {
    ${ModalOverlay} {
      animation: ${fadeOut} 0.5s forwards;
    }
    
    ${ModalContainer} {
      animation: ${slideOut} 0.5s forwards;
    }
  }
`;

export const ModalLoader = styled.div`
  position: absolute;
  z-index: 5;
  top: 0;
  left: 0;
  
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  
  background-color: rgba(0, 0, 0, 0.2);
`;
